import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-4 divide-y lg:divide-y-0 lg:divide-x px-4" }
const _hoisted_2 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-4 grid-flow-col grid-rows-4" }
const _hoisted_4 = { class: "font-medium" }
const _hoisted_5 = { class: "col-span-2 lg:col-span-1 pt-4 lg:pl-4 lg:pt-0" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-4 grid-flow-col grid-rows-4" }
const _hoisted_7 = { class: "font-medium" }

import { // store
		localesStore
	} from '@/store/locales'

	import {
		store as _valueListStore
	} from '@/store/valueLists'
	
	import { // vue
		computed
	} from 'vue'

	
	const __default__ = { name: 'JobCovidRestrictions' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()
	const valueListStore = _valueListStore()

	const covidService = computed(() => {
		let vl
		switch(store.locales.selected) {
		case 'en':
			vl = valueListStore.valueList.covidRestrictionsEn
			break
		case 'ja':
			vl = valueListStore.valueList.covidRestrictionsJa
			break
		case 'kana':
			vl = valueListStore.valueList.covidRestrictionsKana
			break
		default:
			vl = valueListStore.valueList.covidRestrictionsEn
		}

		let restrictions = []
		for(let i = 0; i < vl.length ; i++) {
			const value = vl[i].value
			restrictions.push({label: value, checked: false},)
		}
		
		restrictions.forEach(restriction => {
			if(props.job?.fieldData?.covid_service.includes(restriction.label)) {
				restriction.checked = true
			}
		})

		return restrictions
	})

	const covidRehearsal = computed(() => {
		let vl
		switch(store.locales.selected) {
		case 'en':
			vl = valueListStore.valueList.covidRehearsalRestrictionsEn
			break
		case 'ja':
			vl = valueListStore.valueList.covidRehearsalRestrictionsJa
			break
		case 'kana':
			vl = valueListStore.valueList.covidRehearsalRestrictionsKana
			break
		default:
			vl = valueListStore.valueList.covidRehearsalRestrictionsEn
		}

		let restrictions = []

		for(let i = 0; i < vl.length ; i++) {
			const value = vl[i].value
			restrictions.push({label: value, checked: false},)
		}

		restrictions.forEach(restriction => {
			if(props.job?.fieldData?.covid_rehearsal.includes(restriction.label)) {
				restriction.checked = true
			}
		})

		return restrictions
	})


return (_ctx: any,_cache: any) => {
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_data_display, {
        label: _unref(store).getLabel('260')
      }, {
        custom: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(covidService.value, (restriction) => {
              return (_openBlock(), _createElementBlock("div", {
                key: restriction.label,
                class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !restriction.checked}])
              }, [
                (restriction.checked)
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5"
                    })),
                _createElementVNode("span", _hoisted_4, _toDisplayString(restriction.label), 1)
              ], 2))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_data_display, {
        label: _unref(store).getLabel('261')
      }, {
        custom: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(covidRehearsal.value, (restriction) => {
              return (_openBlock(), _createElementBlock("div", {
                key: restriction.label,
                class: _normalizeClass(["flex justify-start gap-2 items-center", {'opacity-30': !restriction.checked}])
              }, [
                (restriction.checked)
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5"
                    })),
                _createElementVNode("span", _hoisted_7, _toDisplayString(restriction.label), 1)
              ], 2))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["label"])
    ])
  ]))
}
}

})